import {
  createInputFeature,
  ExtractFeaturePayload,
} from '@smartsheet-dataflow/formjs';
import { BridgeFormJSState } from '../Types';
import { dummyDispatch } from '../params/ParamFromSchema';

export const {
  actionCreator: setArrayItemsLabelAction,
  selectorCreator: arrayItemsLabelSelector,
  featureReducer: ArrayItemsLabelFeature,
} = createInputFeature<'arrayItemsLabel', ArrayItemsLabelType>(
  'arrayItemsLabel'
);

export type ArrayItemsLabelType = string;

export type ArrayItemsLabelState = {
  arrayItemsLabel: {
    [inputId: string]: string;
  };
};

export type ArrayItemsLabelPayload = ExtractFeaturePayload<
  typeof setArrayItemsLabelAction
>;

export const reduceArrayItemsLabel =
  (payload: ArrayItemsLabelPayload) => (state: BridgeFormJSState) =>
    ArrayItemsLabelFeature(
      state,
      setArrayItemsLabelAction(dummyDispatch)(payload)
    );
